export default __webpack_public_path__ + "static/B0306-57c06995f1244a38ede411e6f876f4f5.png";